import React, { useContext, useState } from "react";
import {
  Toolbar,
  IconButton,
  Typography,
  styled,
  Box,
  TextField,
  Popover,
  List,
  ListItem,
  ListItemText,
  useMediaQuery,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import MuiAppBar from "@mui/material/AppBar";
import { ExpandMore, NotificationsActive, Search, SearchOutlined, SmsOutlined } from "@mui/icons-material";
import { useTheme } from "@mui/material/styles";
import AuthContext from "../../context/AuthContext";

const drawerWidth = 280;

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  backgroundColor: "#fff",
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

export default function LoggedInHeader({ isOpen, toggleSidebar, isMobile }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const { logout, user } = useContext(AuthContext); // Get logout function
  const [showSearch, setShowSearch] = useState(false);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "user-menu-popover" : undefined;
  const toggleSearch = () => {
    setShowSearch((prev) => !prev);
  };
  return (
    <AppBar position="fixed" sx={{paddingRight:"0px"}} open={isOpen} isMobile={isMobile}>
      <Box className="logged-in-header">
        <Box className='flex' alignItems={'center'}>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={toggleSidebar}
            edge="start"
            sx={[
              {
                marginRight: 5,
                color: "#000",
              },
              isOpen && { display: "none" },
            ]}
          >
            <MenuIcon />
          </IconButton>

          {showSearch ? (
            <TextField
              className="search-text"
              label="Search Input"
              slotProps={{
                inputLabel: {
                  shrink: true,
                },
                input: {
                  endAdornment: <Search />,
                },
              }}
            />
          ) : (
            <IconButton onClick={toggleSearch}>
              <SearchOutlined />
            </IconButton>
          )}
        </Box>
        <Box className="left-header-side">

          <Box
            onClick={handleClick}
            sx={{
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              gap: 1,
              padding: "4px 8px",
              borderRadius: "8px",
              transition: "background 0.2s ease",
              "&:hover": { backgroundColor: "#f5f5f5" },
            }}
          >
            <img
              src={user?.userInfo?.avatar} // your uploaded image
              alt="User"
              style={{
                width: "40px",
                height: "40px",
                borderRadius: "50%",
                objectFit: "cover",
              }}
            />
            {!isMobile &&
              <>
                <Typography variant="body1" sx={{ fontWeight: 500, color: "#333" }}>
                  {user?.userInfo?.user_name || "User Name"}
                </Typography>
                <ExpandMore sx={{ color: "#666" }} /> {/* ⬇️ Down arrow icon */}
              </>
            }
          </Box>

        </Box>
        <Popover
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
        >
          <List sx={{ minWidth: 200, fontSize: '14px' }}>

            <ListItem>
              <Typography variant="body1" fontWeight={'600'}>{user?.userInfo?.user_name}</Typography>
            </ListItem>

            <ListItem button>
              <ListItemText variant="body2" primary="My Profile" />
            </ListItem>
            <ListItem button onClick={() => {
              logout(); // Call logout
            }}>
              <ListItemText variant="body2" primary="Logout" />
            </ListItem>

          </List>
        </Popover>
      </Box>
    </AppBar>
  );
}
